import { 
  LOADING_NOTIFICACIONES, 
  FETCH_TOTAL_NOTIFICACIONES,
  FETCH_DETALLE_NOTIFICACIONES, 
  CHANGE_TAB_ACTIVA_NOTIFICACIONES,
  FETCH_LEIDAS_NOTIFICACIONES,
  FETCH_AJUSTES_NOTIFICACIONES
} from '../actions/types';

const initialState = {
  loadingNotificaciones: false,
  idTabActiva: 0,
  detalle: {},
  total: {},
  leidas: {},
  ajustes: [
    { id: 1, nombre: "Cambios de stock", checked: false },
    { id: 2, nombre: "Cambios de precio", checked: false },
    { id: 3, nombre: "Órdenes nuevas", checked: false },
    { id: 4, nombre: "Órdenes anuladas", checked: false },
    { id: 6, nombre: "Modificaciones de Cuotas", checked: false}
  ]
}

export default function (state = initialState, action) {

  switch (action.type) {

    case LOADING_NOTIFICACIONES:
      return{
        ...state,
        loadingNotificaciones: action.payload
      };

    case CHANGE_TAB_ACTIVA_NOTIFICACIONES:
      return{
        ...state,
        idTabActiva: action.payload
      };

    case FETCH_DETALLE_NOTIFICACIONES:
      return {
        ...state,
        detalle: action.payload
      };

    case FETCH_TOTAL_NOTIFICACIONES:
      return {
        ...state,
        total: action.payload
      };

    case FETCH_LEIDAS_NOTIFICACIONES:
      return {
        ...state,
        leidas: action.payload
      };

    case FETCH_AJUSTES_NOTIFICACIONES:
      const response = action.payload;
      let ajustesUpdate = state.ajustes.map(ajuste => {
        const option = response.find(item => item.idTipoNotificacion === ajuste.id);
        return { ...ajuste, checked: option ? option.activado : false }; 
      });

      return {
        ...state,
        ajustes: ajustesUpdate
      };

    default:
      return state;
  }
}